import { COMPONENT_STATES, COMPONENT_TYPE, DEFAULT_MEDIA_QUERY_PLATFORMS } from 'common/constants';
import { CSS_PROPS, UNIFORM_PROPS } from 'common/constants/component-props';
import { FieldBBErrorType, SelectBBOptionsOrder } from '../fields/constants';
import { createModel } from '../create-model';
import type { CreatedBuildingBlock, CreationContextFor } from '../creation-types';

export const select = ({
	dictionary,
}: CreationContextFor<typeof COMPONENT_TYPE.SELECT>): CreatedBuildingBlock<typeof COMPONENT_TYPE.SELECT> =>
	createModel({
		type: COMPONENT_TYPE.SELECT,
		editorProps: {
			[UNIFORM_PROPS.fieldErrorShow]: FieldBBErrorType.required,
		},
		componentProps: {
			[UNIFORM_PROPS.selectOptions]: [
				{ label: 'Option 1', value: '1' },
				{ label: 'Option 2', value: '2' },
			],
			[UNIFORM_PROPS.selectOptionsOrder]: SelectBBOptionsOrder.alphabet,
			[UNIFORM_PROPS.selectIsMulti]: false,
			[UNIFORM_PROPS.fieldPlaceholder]: dictionary.SELECT.fieldPlaceholder,
			styles: {
				[COMPONENT_STATES.DEFAULT]: {
					[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
						[CSS_PROPS.field.style.text.phColor]: 'rgba(0, 0, 0, 0.54)',
					},
				},
			},
			other: {},
		},
		children: [],
	}) satisfies CreatedBuildingBlock<typeof COMPONENT_TYPE.SELECT>;
